import { Provider } from '@angular/core';

import { GeographyUseCasesImpl } from '@app/domain/use-cases/geography/geography.use-cases';
import { GEOGRAPHY_USE_CASES } from '@app/domain/use-cases/geography/geography.use-cases.contract';

export const geographyUseCasesProvider: Provider = {
  provide: GEOGRAPHY_USE_CASES,
  useClass: GeographyUseCasesImpl
};
